import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "wo-performance-list"
};
const _hoisted_2 = {
  class: "content-container"
};
const _hoisted_3 = {
  key: 0,
  class: "pagination-container"
};
import { ref, onMounted, computed } from 'vue';
import { ElPagination } from 'element-plus';
import DramaPerformance from '@/components/Common/DramaPerformance.vue';
import { request } from '@/manager/net_manager';
import store from "@/store"; // refs

export default {
  __name: 'WOPerformanceList',

  setup(__props) {
    const dataArray = ref([]);
    const pagerCount = ref(5);
    const size = ref(10);
    const total = ref(0);
    const page = ref(0); // computed

    const worldOutlook = computed(() => store.state.world_outlook); // functions

    const getData = () => {
      const parameters = {};

      if (worldOutlook.value !== null) {
        parameters.world_outlook_id = worldOutlook.value.id;
        parameters.page = page.value;
        parameters.size = size.value;
        request('world_outlook/get_wo_performances/', parameters, 'POST').then(response => {
          // console.log(JSON.stringify(response.data.numbers))
          if (response.code === 0) {
            dataArray.value = response.data.performances;
            total.value = response.data.numbers;
          }
        });
      }
    };

    const handlePageChange = index => {
      page.value = index - 1;
      getData();
    }; // lifecycle


    onMounted(() => {
      getData();
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(DramaPerformance, {
        dataArray: dataArray.value
      }, null, 8, ["dataArray"])]), total.value > size.value ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createVNode(_unref(ElPagination), {
        "page-size": size.value,
        "pager-count": pagerCount.value,
        layout: "prev, pager, next",
        total: total.value,
        background: true,
        onChange: handlePageChange
      }, null, 8, ["page-size", "pager-count", "total"])])) : _createCommentVNode("", true)]);
    };
  }

};